// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"603":"f3876c22cfa64794","851":"c539600b4f289d16"}[chunkId] + ".css";
};